import { render, staticRenderFns } from "./ActBaseComplaint.vue?vue&type=template&id=572c2956&scoped=true&"
import script from "./ActBaseComplaint.vue?vue&type=script&lang=js&"
export * from "./ActBaseComplaint.vue?vue&type=script&lang=js&"
import style0 from "./ActBaseComplaint.vue?vue&type=style&index=0&id=572c2956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572c2956",
  null
  
)

export default component.exports